import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useWorkspaces } from "../state/workspaces";
import { useSettings } from "../state/settings";
import { texte } from "../texte";
import { Badge } from "./parts/Badge";
import { Meter } from "./parts/Meter";
import { JoinDialog } from "./parts/Dialogs";
import { useAllWorkspacesStatusPoll } from "../poll/engine";

export function Home() {
  const apiUrl = useSettings((s) => s.apiUrl);
  const order = useWorkspaces((s) => s.order);
  const byName = useWorkspaces((s) => s.byName);
  const upsert = useWorkspaces((s) => s.upsert);
  const setExpertEnabled = useWorkspaces((s) => s.setExpertEnabled);
  const navigate = useNavigate();
  const [joinOpen, setJoinOpen] = useState(false);
  const hasAdminWorkspace = Object.values(byName).some((w) => w.role === "admin");

  useAllWorkspacesStatusPoll(apiUrl, true);

  function handleRedeem(link: { token: string; workspace: string; expert: boolean }) {
    const existing = byName[link.workspace];
    if (!existing) {
      upsert({
        workspace: link.workspace,
        token: link.token,
        role: "student",
        view: "simple",
        origin: "redeemed",
        addedAt: Date.now(),
        notifiedQids: [],
        expertEnabled: link.expert,
      });
    } else if (link.expert && !existing.expertEnabled) {
      setExpertEnabled(link.workspace, true);
    }
    navigate(`/ws/${link.token}/${encodeURIComponent(link.workspace)}`);
  }

  return (
    <main className="page">
      <div className="page-head">
        <h1>{texte.home.title}</h1>
        <span className="hint">{texte.home.autoRefreshHint}</span>
        <div className="actions">
          <button className="btn" onClick={() => setJoinOpen(true)}>
            {texte.home.redeemToken}
          </button>
          {hasAdminWorkspace && (
            <Link className="btn primary" to="/neu">
              {texte.home.newWorkspace}
            </Link>
          )}
        </div>
      </div>
      <div className="ws-grid">
        {order.map((name) => {
          const entry = byName[name];
          if (!entry) return null;
          const state = entry.lastKnown?.state ?? "ready";
          const budget = entry.lastKnown?.budget ?? { total: 0, used: 0 };
          return (
            <Link key={name} className="card ws-card" to={`/ws/${entry.token}/${encodeURIComponent(name)}`}>
              <div className="top">
                <span className="name">{name}</span>
                <Badge state={state} />
              </div>
              <div className="budget-row">
                <Meter used={budget.used} total={budget.total} />
                <span className="num">
                  {budget.used.toLocaleString("de-DE")} / {budget.total.toLocaleString("de-DE")}
                </span>
              </div>
              <div className="foot">
                <span className="origin">{entry.origin === "created" ? "erstellt" : "eingelöst"}</span>
                <span>{texte.home.lastUpdated}</span>
              </div>
            </Link>
          );
        })}
      </div>
      <p className="hint" style={{ marginTop: 28 }}>
        {texte.home.footerHint}
      </p>
      {!hasAdminWorkspace && (
        <p className="hint" style={{ marginTop: 10 }}>
          Sind Sie die Lehrkraft?{" "}
          <Link to="/neu" style={{ color: "var(--accent-ink)" }}>
            Arbeitsbereich anlegen
          </Link>
        </p>
      )}
      {joinOpen && <JoinDialog onClose={() => setJoinOpen(false)} onRedeem={handleRedeem} />}
    </main>
  );
}
